// ===========================================================================
// Module H — Member Outreach Campaign Engine
// Constantes y enums del módulo.
// ===========================================================================

/** Locations disponibles en los dumps de DataDashCareManager. */
export const LOCATIONS = [
  { key: "fort_myers", label: "Fort Myers" },
  { key: "fort_pierce", label: "Fort Pierce" },
  { key: "hialeah", label: "Hialeah" },
  { key: "immokalee", label: "Immokalee" },
  { key: "lake_worth", label: "Lake Worth" },
  { key: "lehigh_acres", label: "Lehigh Acres" },
  { key: "lehigh_acres_5705", label: "Lehigh Acres 5705" },
  { key: "naples", label: "Naples" },
  { key: "naples_5262", label: "Naples 5262" },
  { key: "port_st_lucie", label: "Port St. Lucie" },
];

export const DEFAULT_LOCATION = "fort_myers";

/** Tono semántico por health status del dump. */
export const HEALTH_STATUS_META = {
  "End of Life": { tone: "crit" },
  Complex: { tone: "crit" },
  "At Risk": { tone: "warn" },
  Chronic: { tone: "warn" },
  Acute: { tone: "info" },
  Well: { tone: "ok" },
};

/** Tono por tiempo sin visita. */
export const TIMEFRAME_META = {
  "12+ Months": { tone: "crit" },
  "9 Months": { tone: "warn" },
  "6 Months": { tone: "warn" },
  "3 Months": { tone: "info" },
  "<3 Months": { tone: "ok" },
};

/** Canales de outreach (espejo de outreach.TAB_CHANNEL_CONFIG). */
export const OUTREACH_CHANNELS = ["Call", "SMS", "Email"];

/** Resultados de un intento de contacto (espejo de outreach.TAB_OUTREACH_LOG). */
export const OUTREACH_OUTCOMES = [
  "Reached — appointment requested",
  "Reached — declined visit",
  "Voicemail left",
  "No answer",
  "Wrong number",
  "Email sent",
];

/** Outcomes que cuentan como respuesta del miembro. */
export const RESPONSE_OUTCOMES = [
  "Reached — appointment requested",
  "Reached — declined visit",
];
